/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_A1 as A1,
  rec_AvatarPersona as AvatarPersona,
  rec_Componente_KD_75_68 as Componente_KD_75_68,
  rec_E1 as E1,
  rec_Fr as Fr,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_d1 as d1,
  rec_j1 as j1,
  rec_k1 as k1,
  rec_kx as kx,
  rec_ra as ra,
} from "../../runtime/index.jsx";
export function SelectorHora(e) {
  let t = (0, ReactCompiler.c)(31),
    {
      value: n,
      onChange: r,
      disabled: i,
      placeholder: a,
      className: o,
      id: s,
      "aria-label": c,
    } = e,
    l = i !== void 0 && i,
    u = a === void 0 ? `Elegí la hora` : a,
    f = o === void 0 ? `` : o,
    [p, m] = (0, React.useState)(!1),
    h = (0, React.useRef)(null),
    _ = n || ``,
    v;
  t[0] === _ ? (v = t[1]) : ((v = _.split(`:`)), (t[0] = _), (t[1] = v));
  let [y, b] = v,
    x = y === void 0 ? `` : y,
    S = b === void 0 ? `` : b,
    C;
  (t[2] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((C = () => m(!1)), (t[2] = C))
    : (C = t[2]),
    kx(p, h, C));
  let w;
  t[3] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((w = Array.from(
        {
          length: 24,
        },
        j1,
      )),
      (t[3] = w))
    : (w = t[3]);
  let T = w,
    E;
  t[4] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((E = Array.from(
        {
          length: 60 / E1,
        },
        A1,
      )),
      (t[4] = E))
    : (E = t[4]);
  let D = E,
    O = n || u,
    k = `relative ${f}`,
    A = c ? `${c}: ${O}` : n ? `${O}. Cambiar` : u,
    j;
  t[5] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((j = () => m(k1)), (t[5] = j))
    : (j = t[5]);
  let M = `truncate tabular-nums ${n ? `text-(--text-h)` : `text-(--text)/70`}`,
    N;
  t[6] !== M || t[7] !== O
    ? ((N = <span className={M} children={O} />),
      (t[6] = M),
      (t[7] = O),
      (t[8] = N))
    : (N = t[8]);
  let P;
  t[9] !== l || t[10] !== r || t[11] !== n
    ? ((P = n && !l && (
        <span
          role={`button`}
          tabIndex={0}
          aria-label={`Quitar hora`}
          onClick={(e) => {
            (e.stopPropagation(), r(``));
          }}
          onKeyDown={(e) => {
            (e.key === `Enter` || e.key === ` `) &&
              (e.preventDefault(), e.stopPropagation(), r(``));
          }}
          className={`rounded p-0.5 text-(--text) hover:text-(--error)`}
          children={(0, JSXRuntime.jsx)(ra, {
            className: `h-3.5 w-3.5`,
          })}
        />
      )),
      (t[9] = l),
      (t[10] = r),
      (t[11] = n),
      (t[12] = P))
    : (P = t[12]);
  let F;
  t[13] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((F = <Fr className={`h-4 w-4 text-(--text)`} />), (t[13] = F))
    : (F = t[13]);
  let I;
  t[14] === P
    ? (I = t[15])
    : ((I = (
        <span
          className={`flex shrink-0 items-center gap-1`}
          children={[P, F]}
        />
      )),
      (t[14] = P),
      (t[15] = I));
  let L;
  t[16] !== l || t[17] !== s || t[18] !== A || t[19] !== N || t[20] !== I
    ? ((L = (
        <button
          type={`button`}
          id={s}
          disabled={l}
          aria-label={A}
          onClick={j}
          className={`flex min-h-11 w-full items-center justify-between gap-2 rounded-2xl border border-(--border) bg-(--bg) px-3 py-2 text-sm outline-none transition focus:border-(--accent-border) focus:ring-2 focus:ring-(--accent-bg) disabled:cursor-not-allowed disabled:opacity-60`}
          children={[N, I]}
        />
      )),
      (t[16] = l),
      (t[17] = s),
      (t[18] = A),
      (t[19] = N),
      (t[20] = I),
      (t[21] = L))
    : (L = t[21]);
  let R;
  t[22] !== p || t[23] !== x || t[24] !== S || t[25] !== r
    ? ((R = p && (
        <AvatarPersona
          anclaRef={h}
          className={`rounded-2xl border border-(--border) bg-(--bg) p-3 shadow-2xl`}
          children={[
            <div
              className={`flex justify-center gap-2`}
              children={[
                <Componente_KD_75_68
                  etiqueta={`Hora`}
                  opciones={T}
                  elegida={x}
                  onElegir={(e) => r(`${e}:${S || `00`}`)}
                />,
                <Componente_KD_75_68
                  etiqueta={`Minutos`}
                  opciones={D}
                  elegida={S}
                  onElegir={(e) => r(`${x || d1().slice(0, 2)}:${e}`)}
                />,
              ]}
            />,
            <div
              className={`mt-2 flex items-center justify-between gap-3 border-t border-(--border) pt-2`}
              children={[
                <button
                  type={`button`}
                  onClick={() => {
                    (r(d1()), m(!1));
                  }}
                  className={`text-xs font-medium text-(--accent) hover:underline`}
                  children={`Ahora`}
                />,
                <button
                  type={`button`}
                  onClick={() => m(!1)}
                  className={`text-xs text-(--text) hover:text-(--text-h)`}
                  children={`Listo`}
                />,
              ]}
            />,
          ]}
        />
      )),
      (t[22] = p),
      (t[23] = x),
      (t[24] = S),
      (t[25] = r),
      (t[26] = R))
    : (R = t[26]);
  let z;
  return (
    t[27] !== k || t[28] !== L || t[29] !== R
      ? ((z = <div className={k} ref={h} children={[L, R]} />),
        (t[27] = k),
        (t[28] = L),
        (t[29] = R),
        (t[30] = z))
      : (z = t[30]),
    z
  );
}
